import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { Filter } from '../../ts/helpers/Filter';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { IUser } from '../../ts/ServerApi/types/IUser';
import { GetUsersForDataAlertRequest, IGetUsersForDataAlertResult } from '../serverApi/requests/GetUsersForDataAlertRequest';


export class DataAlertUsersResource {
  private fetcher = new WebClientListResourceFetcher(GetUsersForDataAlertRequest, (result: IGetUsersForDataAlertResult) => result.users);

  public getUsersQuery(dataAlertId: string, filter: string): ResourceQuery<IUser> {
    return new ResourceQuery<IUser>(this.fetcher)
      .withExtraParams({ 'dataAlertId': dataAlertId })
      .withFilters([Filter.stringFieldMatches('displayName', filter)]);
  }
}

export const DataAlertUsers = new DataAlertUsersResource();